import { render } from "./Header.vue?vue&type=template&id=361817e0"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=361817e0&lang=scss"
script.render = render

export default script